/*
 * Public API Surface of magazine-lib
 */

export { MagazineLibComponent } from './lib/magazine-lib.component';
export { MagazineArticleComponent } from './lib/components/magazine-article/magazine-article.component';
export { GeneralArticleComponent } from './lib/components/general-article/general-article.component';
export { MagazineComponent } from './lib/components/magazine/magazine.component';
export { MagazineLibModule } from './lib/magazine-lib.module';
export { MagazineService } from './lib/interfaces/magazine-service.interface';
export { IMagazineResult } from './lib/models/magazine-result';
export * from './lib/magazine-lib.component';
export * from './lib/magazine-lib.module';
